import { render, staticRenderFns } from "./TaxId.vue?vue&type=template&id=54672acb&"
import script from "./TaxId.vue?vue&type=script&lang=js&"
export * from "./TaxId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports